<template>
  <div>
    <!--
    <div class="company-short-descr">
      Компания по производству щебня в Казахстане
    </div>
    
    <router-link v-if="redirectMenu" :to="{name: 'home'}" tag="div">
      <SideMenu :sideMenuVisible="false" :theme="theme"  />
    </router-link>
    <SideMenu v-else :sideMenuVisible="true" :theme="theme" />
    -->

    <div class="cooperation">          
      <div class="cooperation__title">
        По вопросам сотрудничества свяжитесь с нами по <b>e-mail</b>
      </div>      
      <ButtonSlider msg="Оставить заявку" :theme="theme" :mLeft="btnPositinLeft" @btnClick="toggleModal" />
    </div>

    <transition name="fade" mode="out-in">
      <Modal v-show="modalVisible" :theme="theme" @closeModal="toggleModal" />
    </transition>
  </div>
</template>

<script>
import ButtonSlider from "@/components/ButtonSlider.vue";
import SideMenu from "@/components/SideMenu.vue";
import Modal from "@/components/Modal.vue";

export default {
  name: "SidePanel",
  props: {
    theme: {
      type: String,
      required: false,
      default: "",
    },
    redirectMenu: {
      type: Boolean,
      required: false,
      default: false,
    },
    btnPositinLeft: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    ButtonSlider,
    SideMenu,
    Modal,
  },
  data() {
    return {
      modalVisible: false,
    };
  },
  methods: {
    toggleModal() {
      this.modalVisible = !this.modalVisible;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

.company-short-descr {
  margin: 30px auto;
}
.cooperation {
  margin-top: 60px;
}
.cooperation__title {
  font-size: 1.6rem;
  margin-top: 10px;
  margin-bottom: 20px;
  //max-width: 250px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
